import classNames from 'classnames';
import React from 'react';
import styles from './Radio.module.scss';

export interface RadioOption<T extends string | number> {
  value: T;
  label?: JSX.Element | string;
  description?: string;
  disabled?: boolean;
  className?: string;
  // TODO: add if needed: defaultChecked?: boolean;
}

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;
export type RadioProps<T extends string | number> = RadioOption<T> & InputProps;

export const Radio = <T extends string | number>(props: RadioProps<T>) => {
  const { label, description, className, style, disabled, ...rest } = props;
  const hasLabelOrDescription = !!label || !!description;
  return (
    <label
      className={classNames(styles.container, className, {
        [styles.disabled]: disabled,
      })}
      style={style}
    >
      <input type="radio" {...rest} disabled={disabled} />
      {hasLabelOrDescription && (
        <div>
          {label && <span className={styles.label}>{label}</span>}
          {!!description && <span className={styles.description}>{description}</span>}
        </div>
      )}
      {props.children}
    </label>
  );
};
